import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
export function PromiseSection() {
  return <SectionWrapper data-id="element-110">
      <div className="border border-border-custom p-8 md:p-16 text-center max-w-3xl mx-auto bg-ivory" data-id="element-111">
        <h2 className="text-2xl md:text-3xl lg:text-4xl text-text mb-6" data-id="element-112">
          En menos de 15 minutos, vas a saber exactamente qué hacer para volver
          a tu centro.
        </h2>
        <p className="text-lg text-text-secondary mb-10" data-id="element-113">
          Un método simple, estructurado y efectivo para recuperar tu
          estabilidad.
        </p>
        <CTAButton data-id="element-114">Quiero aprender a regularme</CTAButton>
      </div>
    </SectionWrapper>;
}